import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TableComponent } from '../shared/table/table.component';
import { ItemModalComponent } from '../shared/item-modal/item-modal.component';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-historial-evaluacion',
  standalone: true,
  imports: [FormsModule, TableComponent],
  templateUrl: './historial-evaluacion.component.html',
  styleUrl: './historial-evaluacion.component.css',
})
export class HistorialEvaluacionComponent {
  resultadosEvaluacion: any[] = [];
  id_evaluacion!: number;
  columns: { key: string; label: string }[] = [
    { key: 'id_resultado_evaluacion', label: 'ID' },
    { key: 'fecha_evaluacion', label: 'Fecha' },
    { key: 'calificacion', label: 'Nota' },
    { key: 'nivel_alcanzado', label: 'Nivel Alcanzado' },
    { key: 'rolUsuario.usuario.codigo_documento', label: 'Documento' },
  ];
  actions = [
    {
      class: 'bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded',
      icon: 'fas fa-file-alt',
      tooltip: 'Ver Evaluacion',
      callback: (item: any) => {
        //console.log(item);
        this.router.navigate(['/historial-evaluacion-estudiante'], {
          queryParams: {
            id_evaluacion: this.id_evaluacion,
            id_resultado_evaluacion: item.id_resultado_evaluacion,
          },
        });
      },
    },
  ];
  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.id_evaluacion = params['id_evaluacion'];
    });

    this.obtenerResultadosEvaluacion();
  }

  obtenerResultadosEvaluacion() {
    // Swal.fire({
    //   title: 'Cargando...',
    //   text: 'Por favor, espere.',
    //   showConfirmButton: false,
    //   didOpen: () => {
    //     Swal.showLoading();
    //   }
    // })

    this.http
      .get<any[]>(
        `${environment.apiUrl}/resultado-evaluacion?id_evaluacion=${this.id_evaluacion}`
      )
      .subscribe(
        (response) => {
          // Swal.close();
          // console.log(response);
          this.resultadosEvaluacion = response; // Asigna los datos de la API a la variable datos
        },
        (error) => {
          // Swal.close();
          console.error('Error al obtener los datos:', error);
        }
      );
  }

  goToCreateResultados() {
    this.router.navigate(['/create-resultados-evaluaciones'], {
      queryParams: { id_evaluacion: this.id_evaluacion },
    });
  }

  volver(): void {
    this.router.navigate(['/evaluaciones']);
  }
}
